import { gql } from '@apollo/client';
import { MESSAGE_FRAGMENT } from '../fragments';

export const MESSAGE_SENT_SUBSCRIPTION = gql`
  subscription MessageSent($chatId: ID!) {
    chatMessageSent(chatId: $chatId) {
      __typename
      ... on ChatMessageSent {
        chatMessage {
          ...MessageFragment
        }
      }
      ... on Error {
        errorCode
        errorMessage: message
      }
    }
  }

  ${MESSAGE_FRAGMENT}
`;

export const USER_TYPING_SUBSCRIPTION = gql`
  subscription UserTyping($chatId: ID!) {
    userTyping(chatId: $chatId) {
      __typename
      ... on TypingIndicatorEvent {
        typingIndicator {
          chatId
          userId
          userName
          isTyping
          isInternal
        }
      }
      ... on Error {
        errorCode
        errorMessage: message
      }
    }
  }
`;

export const CHAT_UPDATED_SUBSCRIPTION = gql`
  subscription ChatUpdated($accountId: ID!) {
    chatUpdated(accountId: $accountId) {
      chat {
        id
        account_id
        client_account_id
        appointment_id
        estimate_id
        job_id
        invoice_id
        chatType
        name
        clientAccountName
        clientUserFullName
        serviceProviderAccountName
        serviceProviderUserFullName
        serviceProviderAccount {
          users {
            avatarUrl
            role
            firstName
            lastName
          }
        }
        # lastMessage fields included for NEW chats appearing in inbox
        # For EXISTING chats, these are selectively ignored to prevent cache overwrites
        lastMessageText
        lastMessageDateTime
        lastMessageUserId
        lastMessageUserAccountName
        lastMessageUserFirstName
        lastMessageUserLastName
        lastMessageUserAvatarUrl
        spLastReadDateTime
        spHasUnreadMessages
        spUnreadMessageCount
        clientLastReadDateTime
        clientHasUnreadMessages
        clientUnreadMessageCount
        isArchived
        isArchivedClientAccount
        isArchivedServiceProviderAccount
        createdAt
        updatedAt
      }
    }
  }
`;
